<template>
	<div>
		<c-dialog ref="dialog" width="600" @resolve="editHandle">
			<c-form ref="ouSourcingOrderForm" vertical unit-width="100%">
				<c-form-item label="供应商" required>
					<c-select name="supplier_id" async v-model="supplier_id" @search="searchSupplier" @change="getPrice" :clear="false" :value-data="supplierOptions"></c-select>
					<template #handle>
						<c-link icon v-if="auth('b_supplier_edit')" @click="globalDialog('supplierEdit',{})">创建供应商</c-link>
					</template>
				</c-form-item>
				<c-form-item label="已外发数" v-if="out_sourcing_plan_count>0">
					<c-input type="input" name="out_sourcing_plan_count" v-model="out_sourcing_plan_count" disabled></c-input>
				</c-form-item>
				<c-form-item label="本次外发数" required name="counts">
					<c-input type="stepper" decimal="6" name="curr_plan_count" v-model="curr_plan_count" :range="[1,99999999]" step-controls="side"></c-input>
					<template #tip v-if="!isEdit">
						<p style="color:red;" v-if="systemConfig.output_sort && systemConfig.output_sort == '1' && parseFloat(curr_plan_count) > max_out_count">超过本次最大可外发数:{{max_out_count}}</p>
						<p style="color:red;" v-else-if="(parseFloat(out_sourcing_plan_count)+parseFloat(curr_plan_count)) > plan_count">计划外发:{{plan_count}}，已外发:{{out_sourcing_plan_count}}，本次外发:{{curr_plan_count}}，总外发数超过计划外发数</p>
					</template>
				</c-form-item>
				<c-form-item label="计划交期">
					<c-datetime type="datetime" name="estimated_delivery_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
				</c-form-item>
				<c-form-item label="单价">
					<c-input type="stepper" decimal="6" name="price" v-model="price" :range="[0.00,99999999]"  step-controls="side" placeholder="请输入外发单价"></c-input>
				</c-form-item>
				<c-form-item label="金额">
					<c-input type="input" name="money" v-model="money" disabled  append-text="元"></c-input>
				</c-form-item>
				<c-form-item label="备注">
					<c-input type="textarea" name="remark"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'outSourcingEdit',
	
	computed: {
		// 获取dictName选项数据
		...mapState(['systemConfig', 'userInfo', 'systemConfig', 'orderStateNoCancelDic', 'pricingTypeDic', 'auditStateDic'])
	},
	data() {
		return {
			isEdit:false,
			out_sourcing_order_id:0,
			money:null,
			price:0,
			out_sourcing_plan_count:0,
			plan_count:0,
			max_out_count:0,
			curr_plan_count:0,
			supplier_id:0,
			supplierOptions:[],
			task_id:0,
			process_id:0,
			product_id:0
		}
	},
	
	// 监听器
	watch: {
		curr_plan_count(){
			this.calcMoney();
		},
		price(){
			this.calcMoney();
		}
	},
	
	methods: {
		/************打开新增/编辑报工弹窗**************/
		open(data) {
			this.isEdit = false;
			this.out_sourcing_order_id = 0;
			this.supplierOptions = [];
			this.$refs.ouSourcingOrderForm.clear();
			this.task_id = data.id;
			this.process_id = data.process_id;
			this.product_id = data.product_id;
			this.plan_count = data.plan_count;
			this.out_sourcing_plan_count = data.out_sourcing_plan_count||0;
			
			//初始默认数据
			this.initData(data);
			
			this.$refs.dialog.open({
				title: data.out_sourcing_plan_count>0?'『'+data.process_name+'』任务再次外发':'『'+data.process_name+'』任务外发'
			});
		},

		/************打开委外单编辑弹窗**************/
		edit(data) {
			this.isEdit = true;
			this.out_sourcing_order_id = data.id;
			this.task_id = 0;
			this.process_id = data.process_id;
			this.product_id = data.product_id;
			this.plan_count = 0;
			this.out_sourcing_plan_count = 0;
			this.max_out_count = 0;
			this.curr_plan_count = data.plan_count;
			this.price = data.price || 0;
			this.money = data.money;
			this.supplier_id = data.supplier_id;
			this.supplierOptions = data.supplier_id ? [{
				name: data.supplier_name || data.supplier_id,
				value: data.supplier_id
			}] : [];

			this.$refs.ouSourcingOrderForm.clear();
			this.$refs.ouSourcingOrderForm.set({
				supplier_id: data.supplier_id,
				curr_plan_count: data.plan_count,
				estimated_delivery_date: data.estimated_delivery_date,
				price: data.price,
				remark: data.remark
			});

			this.$refs.dialog.open({
				title: '编辑委外单'
			});
		},

		//初始默认数据
		initData(data){
			//获取默认填入的外发数
			this.max_out_count = this.getDefFineCount(data);
			
			let curr_plan_count = null;
			//开启自动填入
			if(this.systemConfig.auto_input_fine_count && this.systemConfig.auto_input_fine_count == '1'){
				curr_plan_count = this.max_out_count;
			}
			
			this.$refs.ouSourcingOrderForm.set({
				estimated_delivery_date: new Date().format('yyyy-MM-dd') + ' 23:59',
				curr_plan_count: curr_plan_count
			});
		},

		/*******搜索【供应商】下拉框信息*****************/
		searchSupplier(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SUPPLIER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/********获取供应商外发价格****************/
		getPrice(){
			if(this.isEdit){
				return;
			}
			this.request({
				url:'/out/sourcing/order/last_price',
				data: {
					process_id: this.process_id,
					supplier_id: this.supplier_id,
					product_id: this.product_id
				},
				success:data => {
					this.price = data;
				}
			})
		},
		
		/***********计算总价**************/
		calcMoney(){
			if (this.curr_plan_count
				&& this.curr_plan_count >0
				&& this.price
				&& this.price > 0
			){
				this.money = parseFloat((this.curr_plan_count * this.price).toFixed(6))
			}else{
				this.money = '0.00';
			}
		},
		
		/***************获取默认填入的外发数***********************/
		getDefFineCount(taskData){
			let de_fine_count = 0;
			if(!taskData){
				return de_fine_count;
			}
			//限制报工顺序 && 并且存在前工序
			if(this.systemConfig.output_sort && this.systemConfig.output_sort == '1' && taskData.preTaskInfoDto){
				de_fine_count = (taskData.preTaskInfoDto.w_ok_count - taskData.out_sourcing_plan_count)<0? 0:parseFloat(((taskData.preTaskInfoDto.w_ok_count - taskData.out_sourcing_plan_count) * taskData.output_ratio).toFixed(2));
			}else{
				de_fine_count = (taskData.plan_count - taskData.out_sourcing_plan_count)<0? 0:parseFloat((taskData.plan_count - taskData.out_sourcing_plan_count).toFixed(6));
			}
			//未完成首检，并且可报工数>0
			if(taskData.firest_test_state == 1 && de_fine_count > 0){
				de_fine_count = 1;
			}
			return de_fine_count;
		},
		
		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			if(!this.isEdit && this.task_id == 0){
				this.$message({
					message:'任务信息异常，请重试',
				});
				return false;
			}
			if(this.isEdit && this.out_sourcing_order_id == 0){
				this.$message({
					message:'委外单信息异常，请重试',
				});
				return false;
			}
			this.$refs.ouSourcingOrderForm.submit({
				url: this.isEdit ? '/out/sourcing/order/edit' : '/out/sourcing/order/add',
				rule: {
					supplier_id: '请选择供应商',
					curr_plan_count: '请填写外发数量',
					counts: data =>{
						var flag = true;
						if(data.curr_plan_count == 0){
							return "外发数不能为0";
						} 
						return flag||"请完善外发信息";
					},
				},
			    dataFormatter: data => {
					if(this.isEdit){
						data.id = this.out_sourcing_order_id;
					}else{
						data.task_id = this.task_id;
					}
					data.price = data.price||undefined;
					data.plan_count = data.curr_plan_count;
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						type: 'success',
						message: this.isEdit ? '委外单编辑成功' : '委外订单创建成功'
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>